import React, {useRef, useReducer} from "react";
import styled from "styled-components";
import CpmCommYearMonthDay from "../Components/Common/CpmCommYearMonthDay";
import CpmCommYearMon from "../Components/Common/CpmCommYearMon";
import CpmCommYear from "../Components/Common/CpmCommYear";
import CpmCommAgncyOffc from "../Components/Common/CpmCommAgncyOffc";
import CpmCommYearMonFromTo from "../Components/Common/CpmCommYearMonFromTo";
import CpmCommDateFromToWeek from "../Components/Common/CpmCommDateFromToWeek";
import CpmCommCli from "../Components/Common/CpmCommCli";
import CpmCommCodeCheckbox from "../Components/Common/CpmCommCodeCheckbox";
import CpmCommCodeRadio from "../Components/Common/CpmCommCodeRadio";
import CpmCommInput from "Components/Common/CpmCommInput";
import CpmCommTextarea from "Components/Common/CpmCommTextarea";
import { Button } from "reactstrap";
import { checkCompsValidate } from "script/commFunc";
import CpmCommInputSelect from "Components/Common/CpmCommInputSelect";
import CpmCommTargetInput from "Components/Common/CpmCommTargetInput";



/**
 *
 * User : 백욱진
 * Date : 2023.05.04
 * @ file : modules/CommExample.js
 * @ Desc : 공통컴포넌트 리스트 페이지
 */

const Wrapper = styled.div`
  display: flex;
  @media screen and (max-width: 800px) {
    display: inline-block;
  }
`;

const Col = styled.div`
  // min-width: 50%;
  max-width: 100%;
  height: auto;
`;

const TextArea = styled.div`
  min-width: 230px;
  align-self: center;
  width: auto;
  font-size: 10px;
`;

const CommponentArea = styled.div`
  display: flex;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  padding: 10px;
`;

const reducer = (params, props) => {
    return ({...params, ...props});
}

const CommExample = () => {
    const [params, setParams] = useReducer(reducer, {});
    const focusCliRef = useRef(null); // 광고주 ref 

    // 광고주 input으로 포커스 이동 함수
    const handleFocusCliRef = () => {
        focusCliRef.current.focus();
    }

    const commonProps = {
        params,
        setParams,
        focusCliRef,
        handleFocusCliRef,
        essential: true,
    };

    const onClick_BtnValAll = () => {
        checkCompsValidate('form')
    }

    return (
        <div className="page-content" id='form'>
            <Button onClick={onClick_BtnValAll}> 전체 validation 체크 </Button>
            <Wrapper>
                <Col>
                    <Row>
                        <TextArea>CommYearMonthDay</TextArea>
                        <CommponentArea>
                            <CpmCommYearMonthDay {...commonProps} />
                        </CommponentArea>
                    </Row>

                    <Row>
                        <TextArea>CommYearMon</TextArea>
                        <CommponentArea>
                            <CpmCommYearMon {...commonProps} />
                        </CommponentArea>
                    </Row>

                    <Row>
                        <TextArea>CommYearMonFromTo</TextArea>
                        <CommponentArea>
                            <CpmCommYearMonFromTo {...commonProps} />
                        </CommponentArea>
                    </Row>

                    <Row>
                        <TextArea>CommYear</TextArea>
                        <CommponentArea>
                            <CpmCommYear {...commonProps} />
                        </CommponentArea>
                    </Row>

                    <Row>
                        <TextArea>CommDateFromToWeek(type=null)</TextArea>
                        <CommponentArea>
                            <CpmCommDateFromToWeek {...commonProps} />
                        </CommponentArea>
                    </Row>

                    <Row>
                        <TextArea>CommDateFromToWeek(type=week)</TextArea>
                        <CommponentArea>
                            <CpmCommDateFromToWeek type="week" {...commonProps} />
                        </CommponentArea>
                    </Row>

                    <Row>
                        <TextArea>CommDateFromToWeek(type=month)</TextArea>
                        <CommponentArea>
                            <CpmCommDateFromToWeek type="month" {...commonProps} />
                        </CommponentArea>
                    </Row>

                    <Row>
                        <TextArea>CommDateFromToWeek(type=year)</TextArea>
                        <CommponentArea>
                            <CpmCommDateFromToWeek type="year" {...commonProps} />
                        </CommponentArea>
                    </Row>

                    <Row>
                        <TextArea>CommDateFromToWeek(type=weekmon)</TextArea>
                        <CommponentArea>
                            <CpmCommDateFromToWeek type="weekmon" {...commonProps} />
                        </CommponentArea>
                    </Row>

                    <Row>
                        <TextArea>CommCodeCheckbox</TextArea>
                        <CommponentArea>
                            <CpmCommCodeCheckbox {...commonProps} isAll/>
                        </CommponentArea>
                    </Row>

                    <Row>
                        <TextArea>CommCodeRadio</TextArea>
                        <CommponentArea>
                            <CpmCommCodeRadio {...commonProps} />
                        </CommponentArea>
                    </Row>
                </Col>

                <Col>
                    <Row>
                        <TextArea>commAgncyOffc</TextArea>
                        <CommponentArea>
                            <CpmCommAgncyOffc {...commonProps} />
                        </CommponentArea>
                    </Row>
                    <Row id='main'>
                        <TextArea>commCli</TextArea>
                        <CommponentArea>
                            <CpmCommCli {...commonProps} />
                        </CommponentArea>
                    </Row>
                    <Row id='main2'>
                        <TextArea>commInput</TextArea>
                        <CommponentArea>
                            <CpmCommInput id="input" {...commonProps} />
                        </CommponentArea>
                    </Row>
                    <Row>
                        <TextArea>commTextarea</TextArea>
                        <CommponentArea>
                            <CpmCommTextarea id="textarea" {...commonProps} />
                        </CommponentArea>
                    </Row>
                    <Row>
                        <TextArea>commInputSelect</TextArea>
                        <CommponentArea>
                            <CpmCommInputSelect {...commonProps} />
                        </CommponentArea>
                    </Row>
                    <Row>
                        <TextArea>commTargetInput</TextArea>
                        <CommponentArea>
                            <CpmCommTargetInput {...commonProps} />
                        </CommponentArea>
                    </Row>
                </Col>
            </Wrapper>
        </div>
    );
};

export default CommExample;
